import React from 'react';
import { Chip } from '@mui/material';

interface StatusChipProps {
  status: string;
  variant?: 'verification' | 'analysis' | 'risk';
}

const StatusChip: React.FC<StatusChipProps> = ({ status, variant = 'verification' }) => {
  const getColor = () => {
    const lowerStatus = status.toLowerCase();
    
    switch (variant) {
      case 'verification':
        switch (lowerStatus) {
          case 'approved': return 'success';
          case 'pending_review': return 'warning';
          case 'rejected': return 'error';
          default: return 'default';
        }
      
      case 'analysis':
        switch (lowerStatus) {
          case 'completed': return 'success';
          case 'pending_review': return 'warning';
          case 'failed': return 'error';
          default: return 'default';
        }
      
      case 'risk':
        switch (lowerStatus) {
          case 'high': return 'error';
          case 'medium': return 'warning';
          case 'low': return 'success';
          default: return 'default';
        }
      
      default:
        return 'default';
    }
  };

  const formatLabel = (status: string) => {
    return status.replace(/_/g, ' ').toUpperCase();
  };

  return (
    <Chip
      label={formatLabel(status)}
      color={getColor() as any}
      size="small"
    />
  );
};

export default StatusChip;